import { deepClone, formatNumberToThousands } from '@/utils'
import { stopBubble } from '@/utils/commonUtil'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import { exportExcel } from '@/utils/tableDataExportUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as TrackingConstants from '@/class/cargo/model/parameters/TrackingConstants'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import {
  advancedQuery,
  isContractExpiredForbidCreateJob,
  queryLastModifyBookingByDay,
  acceptJobFunc,
  preVerifyRejectFunc,
  reviewThroughFunc,
  reviewRefusalFunc,
  batchPreVerifyRejectFunc
} from '@/api/integratedJob/ieBooking'
import {
  validateJobForDelete,
  batchDeleteJob,
  validateChargeLockStatus,
  batchManagerCommit,
  batchReturnSubmit, batchModifyChargeLockStatus, updateJobCustomJobType, batchCheckJobsCredit, syncChargeConfirmBatch
} from '@/api/booking/job'
import {
  getJobSopStates,
  getTrackingListByLob,
  canBatchShutout,
  batchShutout,
  statisticsJobs,
  batchPreCommit,
  batchCommit,
  checkChargeStateVerify,
  batchRemoveCharge
} from '@/api/seaExport/seaExportJob'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { cache } from '@/utils/cacheManager'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getLocationList } from '@/api/location'
import { getObjectByCache, getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { recordSelectedStatus } from '@/utils/agGrid'
import LocalStorageUtils from '@/utils/localStorageUtils'
import lodash from 'lodash'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { updateState } from '@/api/booking/jobCooperate'
import { getInstructions } from '@/api/sysManage/uiCustom'

export default {
  methods: {
    // 加载指令按钮
    async loadInstructionButtons() {
      let module = 0
      switch (this.integratedLogisticsType) {
        case SeaExportConstants.STUFFY_IC.code:
          module = UICustomConstants.IC_BOOKING_MODULE
          break
        case SeaExportConstants.STUFFY_CL.code:
          module = UICustomConstants.CL_BOOKING_MODULE
          break
        case SeaExportConstants.STUFFY_TT.code:
          module = UICustomConstants.TT_BOOKING_MODULE
          break
      }
      if (module) {
        const res = await getInstructions({
          module,
          branchId: this.$store.getters.currentOfficeId,
          useHqSet: true
        })
        this.instructioinBtns = res.data
      } else {
        this.instructioinBtns = []
      }
    },
    // 查询[简单查询/高级查询]
    toQuery(saveJobNos, removedJobNos) {
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.toBackQuery(saveJobNos, removedJobNos)
        return
      }
      if (this.isAdvancedQuery) {
        this.filter.jobNo = ''
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      let data
      if (typeof keyword !== 'undefined') {
        data = [
          new AdvancedSearchOption(null, 'job.JOB_NO', keyword, 'LIKE').formatObj2Json()
        ]
        this.filter.jobNo = keyword
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        filter.conditions = this.handleConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(filter.conditions)
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      filter.appendQuery = this.appendQuery
      const colorType = Number(this.$store.state.settings.colorType) === 1
      filter.requires = []
      if (colorType) {
        filter.requires.push('financeColor')
      }
      const loading = getLoading4Cxt(this)
      if (this.notRefresh) {
        console.log('请等上次查询完再执行查询操作')
        return
      }
      this.notRefresh = true
      advancedQuery(filter).then(res => {
        let selectedStatus = null
        if (!this.unNeedSelected) {
          selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
        }
        let results = res.data.list
        if (this.appendQuery) { // 追加查询数据去重
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
          this.total = results.length
        } else {
          this.pageNum = res.data.pageNum
          this.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
          this.pageCount = res.data.pages
        }
        this.rowData = SopUtil.resolveSopState(results)
        if (this.gridApi) this.gridApi.clearFocusedCell()
        if (!this.unNeedSelected && selectedStatus) {
          selectedStatus.revert()
        }
      }).finally(() => {
        this.notRefresh = false
        loading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        if (this.ieVerifyGrid) {
          data.push(new AdvancedSearchOption(null, 'job.PREVERIFY_STATE', [0, 1, 2, 3, 6], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json())
        } else {
          const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
          data.push(option.formatObj2Json())
        }
      }
      // 如果是国际卡航、集卡拖车、整车零担 单独的菜单查询 把类型拼上去
      if (this.integratedLogisticsType) {
        const containerLoadType = [this.integratedLogisticsType]
        const option = new AdvancedSearchOption(null, 'ieJob.CONTAINER_LOAD_TYPE', containerLoadType, AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option.formatObj2Json())
      }
      const lcOption = AdvancedSearchOption.removeOption('job.localSevice', data)
      if (lcOption) {
        const codes = lcOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.INTEGRATED_TYPES, code)
          if (service) {
            services.push(service)
          }
        }
        const stuffingTypes = this.filterStuffingType(services)
        for (const stuffing in stuffingTypes) {
          data.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
        }
      }

      // CARGO-33089 14077-艾尔布勒斯 综合物流-整车/零担，系统管理员都无法查到业务
      if (AdvancedSearchOption.hasField('trackingInfo._multipleState_', data)) {
        const option = AdvancedSearchOption.getOption('trackingInfo._multipleState_', data)
        if (Object.getOwnPropertyNames(option.value).length === 0) {
          AdvancedSearchOption.removeOption('trackingInfo._multipleState_', data)
        }
      }
      return data
    },
    filterStuffingType(items) {
      if (items.length > 0) {
        if (items.length > 1 && this.isSelfDeliveryExits(items)) {
          // 如果存在自拉自送则删除内装箱和门点装箱
          for (let i = items.length - 1; i >= 0; --i) {
            const stuffyType = items[i]
            if (stuffyType.code === 'IS' || stuffyType.code === 'DD') {
              items.splice(i, 1)
            }
          }
        }
        return this.convertStuffyTypeToQuery(items)
      }
      return []
    },
    isSelfDeliveryExits(items) {
      for (const stuffyType of items) {
        if (stuffyType.code === 'SD') {
          return true
        }
      }
      return false
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.WAREHOUSING')
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'CT') {
          result.push('reJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('reJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('reJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 返回查询
    toBackQuery(jobs, removedJobs) {
      setTimeout(() => {
        this.backHandleQueryData(jobs, removedJobs)
      })
    },
    backHandleQueryData(results, removedJobs) {
      let hasNew = false // 是否有新增数据
      for (const item of results) {
        const index = this.rowData.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.rowData[index] = item
        } else {
          this.rowData.push(item)
          hasNew = true
        }
      }
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        if (removedJobs.findIndex(p => p.uuid === this.rowData[i].uuid) >= 0) {
          this.rowData.splice(i, 1)
        }
      }
      if (hasNew || removedJobs.length > 0) {
        /* 记录勾选项 */
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0) {
          const keys = Array.from(rows, p => p.uuid)
          setTimeout(() => {
            const masterSelectedSet = new Set()
            const nodes = this.gridApi.rowModel.rowsToDisplay
            for (const node of nodes) {
              if (!node.data) {
                continue
              }
              if (keys.includes(node.data.uuid)) {
                node.setSelected(true)
                if (node.data.masterFlag) {
                  masterSelectedSet.add(node.data.uuid)
                }
              } else {
                if (node.data.lclMasterUuid && masterSelectedSet.has(node.data.lclMasterUuid)) {
                  setTimeout(() => {
                    node.setSelected(false)
                  })
                }
              }
            }
          }, 100)
        }
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        for (const item of results) {
          const node = nodes.find(p => p.data && p.data.uuid === item.uuid)
          node.setData(item)
        }
        // this.gridApi.resetRowHeights()
      }
    },
    // 业务编号右边放大镜图标点击事件处理
    showBusinessInfo(e) {
      stopBubble(e)
      this.templateSelectorDialog.ctx = new IntegratedJob(this.selectedRow)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedRow.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 查看
    async toLook(row) {
      const action = row && Number(cache.config.get('JobDirectEditingStatus')) === 1 && row.jobState === 0 && !JobUtils.isBlockJob(row) && (await SecurityUtil.canEdit(new IntegratedJob(row))) ? 'edit' : 'look'
      this.$emit(action, row || this.selectedRow)
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 编辑
    toEdit() {
      this.$emit('edit', this.selectedRow)
    },
    // 复制
    toCopy() {
      const jobList = this.selectedRows
      if (!jobList || jobList.length <= 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      if (jobList.length > 1) {
        this.$message.warning(this.$t('Message.SelectOneJob'))
        return
      }
      const usefulJob = jobList[0]
      if (usefulJob.customerId) {
        const loading = getLoading4Cxt(this)
        isContractExpiredForbidCreateJob(usefulJob.customerId).then(res => {
          loading.close()
          if (res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.$emit('copy', usefulJob)
          }
        }).catch(() => {
          loading.close()
        })
      } else {
        this.$emit('copy', usefulJob)
      }
    },
    // 删除
    async toDelete() {
      const rows = this.selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState > 0) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('Message.IsNotOperationStatus'))
          return
        }
      }
      const jobKeys = []
      for (const row of rows) {
        jobKeys.push(row.uuid)
      }
      const loading = getLoading4Cxt(this)
      const res = await validateJobForDelete({ keys: jobKeys }).finally(() => {
        loading.close()
      })
      this.handlerDelete(res.data, jobKeys)
    },
    // 删除验证结果
    handlerDelete(delMap, jobKeys) {
      if (!delMap.canDelete) {
        if (delMap.hasDelete) {
          this.$message.warning(this.$t('CargoMsg.HasDeletedForDeleteJob'))
        }
        if (delMap.existsSlaveJob) {
          this.$message.warning(this.$t('CargoMsg.HasSlaveJobForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsCharge) {
          this.$message.warning(this.$t('CargoMsg.HasChargeForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsMergeJob) {
          this.$message.warning(this.$t('CargoMsg.HasMergeForDeleteJob', [delMap.jobNo]))
        }
        return
      }
      this.$confirm(this.$t('Message.SureDeleteThese') + jobKeys.length + this.$t('Message.OrdersOfBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(async() => {
        const loading = getLoading4Cxt(this)
        try {
          const res = await batchDeleteJob({ jobKeys: jobKeys })
          await this.handlerDeleteResult(res)
        } finally {
          loading.close()
        }
      }).catch(() => { })
    },
    // 删除成功处理
    async handlerDeleteResult(res) {
      const result = res.data
      if (result > 0) {
        const rows = this.selectedRows
        for (const row of rows) {
          const index = this.rowData.findIndex(p => p.uuid === row.uuid)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
        }
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
      }
    },
    // 导出公共
    exportHandle() {
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      switch (this.exportCommand) {
        case this.$t('SeaExport.ExportToExcel'):
          this.toExportToExcel()
          break
        case this.$t('SeaExport.ExportWithSOPToExcel'):
          this.toExportWithSOPToExcel()
          break
      }
    },
    // 导出Excel
    toExportToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      const newRows = deepClone(this.selectedRows)
      this.toExport(newRows, allDisplayedColumns)
    },
    // 导出Excel(含SOP明细)
    async toExportWithSOPToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // copy一个新的
      const newRows = deepClone(this.selectedRows)
      if (!newRows || newRows.length <= 0) return
      const jobKeys = Array.from(newRows, p => p.uuid)
      let jobSopStates = {}
      await getJobSopStates(jobKeys).then(res => {
        jobSopStates = res.data
      })
      // 查询海运出口的所有SOP节点
      const sopTemplateMap = SopUtil.getSopTemplateMap(newRows)
      const headerNameMap = new Map()
      const sopColumns = []
      // 循环每条业务数据
      for (let i = 0; i < newRows.length; i++) {
        const reJob = newRows[i] // 当前行
        if (!sopTemplateMap.hasOwnProperty(reJob.trackingTemplateUuid)) {
          continue
        }
        const trackMap = sopTemplateMap[reJob.trackingTemplateUuid]
        const newSopState = (jobSopStates && Object.prototype.hasOwnProperty.call(jobSopStates, reJob.uuid)) ? jobSopStates[reJob.uuid] : ''
        const currentJobSopState = !newSopState ? reJob.sopState : newSopState // 当前行的SOP数据

        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          if (trackMap.hasOwnProperty(columnName)) {
            const track = trackMap[columnName]
            if (track && (Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_E.code) || Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_SUPPLEMENT.code))) {
              continue
            }
          }
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? this.$t('Message.NotStart') : oldColumnValue
          //
          if (!headerNameMap.has(columnName)) {
            headerNameMap.set(columnName, columnValue)
            sopColumns.push({ headerName: columnName, field: columnName, columnType: 'SOP' })
          }
          newRows[i][columnName] = columnName + ' ' + columnValue
        }
      }
      // 获取所有列
      const allColumns = [...allDisplayedColumns, ...sopColumns]
      this.toExport(newRows, allColumns)
    },
    toExport(rows, columns) {
      const fileName = 'IEBookingList'
      exportExcel(fileName, rows, columns)
    },
    // 修改SOP状态
    editState() {
      if (this.selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAJob'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      let lob = null
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
      })
      this.stateDialog.rows = this.selectedRows
      this.stateDialog.visible = true
    },
    getTrackingDetail(trackingCode) {
      this.stateDialog.trackingDetailCode = ''
      this.stateDialog.trackingDetailList = []
      const trackingList = this.stateDialog.trackingList.filter(item => item.code === trackingCode)
      this.stateDialog.trackingDetailList = trackingList[0].trackingDetail
    },
    // 退关
    toShutOut() {
      const jobKeys = []
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.IsNotOperationStatusCannotBeShutOut'))
          return
        }
        // 财务审核
        if (item.jobState === 2) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
          return
        }
        // 退关
        if (item.shutOut) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenShutOuted'))
          return
        }
        jobKeys.push(item.uuid)
      }
      this.shutOutDialog.jobKeys = jobKeys
      canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
    },
    // 验证退关
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      this.shutOutDialog.shutOutButtonShow2 = ''
      if (result === 0) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.CustomsClearanceNoChargeNoChange')
      } else if (result === 1) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.ClearFeeNoChargeCustomsClearance')

        this.shutOutDialog.shutOutButtonShow2 = 'none'
      } else if (result === 2) {
        this.$message.warning(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
      } else if (result === 3) {
        this.$message.warning(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
      }
      if (result === 0 || result === 1) {
        this.shutOutDialog.visible = true
      }
    },
    // 有费用退关
    hasChargeShutoutHandler() {
      const jobKeys = Array.from(this.selectedRows, p => p.uuid)
      const hasCharge = true
      this.shutOutDialog.hasCharge = hasCharge
      batchShutout({ jobKeys, hasCharge }).then(res => this.batchShutoutResult(res))
    },
    // 无费用退关
    async noHasChargeShutoutHandler() {
      const jobKeys = Array.from(this.selectedRows, p => p.uuid)
      const hasCharge = false
      this.shutOutDialog.hasCharge = hasCharge
      const checkNode = CheckRuleConstants.NO_FEE_REFUND.code
      const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, this.selectedRows[0].lob)
      if (hasCheckRule) {
        const callBack = async() => { batchShutout({ jobKeys, hasCharge }).then(res => this.batchShutoutResult(res)) }
        this.checkingManager(this.selectedRows, checkNode, callBack, null)
      } else {
        batchShutout({ jobKeys, hasCharge }).then(res => this.batchShutoutResult(res))
      }
    },
    // 退关处理结果
    batchShutoutResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.$message.success(this.$t('Message.ShutOutSuccessfully') + ': ' + len)
      this.shutOutDialog.visible = false
      if (len === 0) {
        return
      }
      const objJobKey = {}
      const jobKeys = this.shutOutDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }
      for (const reJob of this.rowData) {
        if (objJobKey.hasOwnProperty(reJob.uuid) && objJobKey[reJob.uuid] === reJob.uuid) {
          const hasCharge = this.shutOutDialog.hasCharge
          reJob.shutOut = true
          if (!hasCharge) {
            reJob.jobState = SystemConstants.SHUT_OUT
          }
        }
      }
      this.shutOutDialog.hasCharge = false
      this.shutOutDialog.jobKeys = []
      this.gridApi.refreshCells({ force: true })
    },
    // 批量打印
    onBatchPrint(command) {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      const jobKeys = Array.from(this.selectedRows, p => p.uuid)
      if (jobKeys.length > 0) {
        this.templateSelectorDialog.ctx = new IntegratedJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'IEJOBLIST'
        this.templateSelectorDialog.data = {
          'JOB_UUID': jobKeys,
          'printSource': DocumentConstants.BATCH_PRINT_IE.code
        }
        // 是否按照多个打印
        if (command === this.$t('queryJob.PrintByBusinessNumber')) {
          Object.assign(this.templateSelectorDialog.data, {
            'JOB_UUID': jobKeys[0],
            multiplePrint: true,
            multipleJobUuid: jobKeys
          })
        }
        this.templateSelectorDialog.visible = true
      }
    },
    // 统计
    async toStatistics() {
      this.statisticsClean()
      const loading = getLoading4Cxt(this)
      try {
        await this.handleStatistics(false)
        this.statisticsDialog.visible = true
      } finally {
        loading.close()
      }
    },
    async handleStatistics(isChangeContainShutOutJob = false) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('Message.PleaseSelectAJob'))
      }
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let weight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let masterCount = 0
      let count = 0
      let lob = ''
      // 列表勾选的数据是否都为”已退关“
      let allJobShutOut = true
      for (const job of rows) {
        if (!job.shutOut) {
          allJobShutOut = false
          break
        }
      }
      for (const job of rows) {
        if (job.shutOut) {
          // 弹窗手动修改”是否包含退关“
          if (isChangeContainShutOutJob && !this.statisticsDialog.containShutOutJob) {
            continue
          } else if (!isChangeContainShutOutJob && !allJobShutOut) { // 第一次打开弹窗
            continue
          }
        }
        count++
        if (lob === '') lob = job.lob
        jobKeys.push(job.uuid)
        if (job.masterFlag) {
          masterCount += 1
        } else {
          weight += isNaN(job.weightActual) ? 0 : job.weightActual
          cubage += isNaN(job.cubageActual) ? 0 : job.cubageActual
          chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
          slavesCount += 1
        }
        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtMaster = masterCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(weight), 3)
      this.statisticsDialog.txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(cubage), 3)
      this.statisticsDialog.txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(chargeWeight), 3)
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      if (!isChangeContainShutOutJob && allJobShutOut) {
        this.statisticsDialog.containShutOutJob = true
      }
      await statisticsJobs({ jobKeys: jobKeys, lob: 'IE', containShutOutJob: this.statisticsDialog.containShutOutJob }).then(res => this.statisticsJobsResult(res.data))
    },
    // 清空统计对话框
    statisticsClean() {
      for (const key in this.statisticsDialog) {
        this.statisticsDialog[key] = ''
      }
      this.statisticsDialog.containShutOutJob = false
    },
    // 统计结果
    statisticsJobsResult(res) {
      if (res) {
        this.statisticsDialog.txt20 = res.b20
        this.statisticsDialog.txt40 = res.b40
        this.statisticsDialog.txt40hq = res.b40h
        this.statisticsDialog.txt45 = res.b45
        this.statisticsDialog.txtTeu = res.teu
      } else {
        this.statisticsDialog.txt20 = 0
        this.statisticsDialog.txt40 = 0
        this.statisticsDialog.txt40hq = 0
        this.statisticsDialog.txt45 = 0
        this.statisticsDialog.txtTeu = 0
      }
    },
    // 批量提交
    async toBatchSubmit() {
      let jobKeys = []
      let selectedJobs = []
      const allowBatchSubmitJobState = cache.config.get('AllowBatchSubmitJobState')
      const allowBatchSubmitJobStateArr = allowBatchSubmitJobState ? allowBatchSubmitJobState.split(',') : []
      const operateStr = SystemConstants.OPERATING.toString()
      const preCommitStr = SystemConstants.PRE_COMMIT.toString()
      const len = allowBatchSubmitJobStateArr.length
      for (const item of this.selectedRows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (len > 1 && allowBatchSubmitJobStateArr.includes(operateStr) && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.OPERATING || Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchSubmitCheck'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(operateStr) && !(Number(item.jobState) === SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckOperate'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckPre'))
          return
        }
        jobKeys.push(item.uuid)
        selectedJobs.push(item)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            selectedJobs = []
            for (const item of this.selectedRows) {
              if (jobKeys.indexOf(item.uuid) !== -1) {
                selectedJobs.push(item)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_COMMIT.code
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = selectedJobs // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = () => { this.batchCommitCall() }
            this.checkingManager(selectedJobs, checkNode, callBack, null, true)
          } else {
            const callBack = () => { this.batchCommitCall() }
            this.checkingManager(selectedJobs, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('queryJob.AreTicketsSubmitted'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            const officeId = this.$store.getters.currentOfficeId
            batchCommit({ jobKeys: jobKeys, officeId: officeId }).then(res => this.handlerCommitResult(res))
          }).catch(() => { })
        }
      }
    },
    // 批量提交回调
    batchCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        this.$logger.log('提交——jobKeys：', jobKeys)
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchCommit({ jobKeys: jobKeys, officeId: officeId }).then(res => this.handlerCommitResult(res))
      }
    },
    // 批量预提交回调
    batchPreCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchPreCommit({ jobKeys: jobKeys, officeId: officeId }).then(res => this.handlerPreCommitResult(res))
      }
    },
    // 批量预提交处理结果
    handlerPreCommitResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.toQuery()
      this.$message.success(this.$t('Message.BatchSubmittedPreSuccessfully') + ': ' + len)
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false, newJob = null) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.newJob = newJob
        this.batchCheckingWindow.visible = true
      }
    },
    // 批量提交处理结果
    handlerCommitResult(res) {
      const list = res.data
      const len = !list ? 0 : list.length
      this.toQuery()
      this.$message.success(this.$t('Message.BatchSubmittedSuccessfully') + ': ' + len)
    },
    // 批量预提交
    toBatchPreSubmit() {
      const jobKeys = []
      for (const j of this.selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(j.jobState) !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        jobKeys.push(j.uuid)
      }
      // 检查应付费用是否全部审核
      checkChargeStateVerify(jobKeys).then(res => this.checkChargeStateVerifyResult(res))
    },
    // 检查应付费用是否全部审核
    async checkChargeStateVerifyResult(res) {
      const result = res.data
      if (this.checkApChargeVerify && result === 0) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const officeId = this.$store.getters.currentOfficeId
      const rows = this.selectedRows
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = () => { this.batchPreCommitCall() }
            this.checkingManager(rows, checkNode, callBack, null, true)
          } else {
            const callBack = () => { this.batchPreCommitCall() }
            this.checkingManager(rows, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesPreSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchPreCommit({ jobKeys: jobKeys, officeId: officeId }).then(res => this.handlerPreCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量处理费用
    chargeHandle() {
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(this.selectedRows)
      }
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.EditCharges'):
          this.toEditCharge()
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.toDeleteCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    async toAddCharge() {
      const selectedJobs = []
      for (const obj of this.selectedRows) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      // if (!await this.validateChargeLocked(selectedJobs)) return
      // this.addChargeDetailDialog.selectedJobs = selectedJobs
      // this.addChargeDetailDialog.visible = true
      this.chargeTypeDialog.type = this.role.addPayableChargeRole ? 2 : 1
      this.chargeTypeDialog.selectedJobs = selectedJobs
      this.chargeTypeDialog.visible = true
    },
    onChargeTypeDialogConfirm() {
      this.chargeTypeDialog.visible = false
      // 应收是否锁定
      const type = this.chargeTypeDialog.type
      const rows = this.chargeTypeDialog.selectedJobs
      if (!rows || rows.length === 0) return
      if (type === 0) {
        const chargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0 && p.payableChargeLockedStatus > 0)
        if (chargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ARAP_Locked'))
          return
        }
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      } else if (type === 1) {
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
      } else if (type === 2) {
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      }

      if (this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        if (type === 0 || type === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AR'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && this.role.addPayableChargeRole) {
        if (type === 0 || type === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AP'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Cannot_Add_Charge'))
        return
      }

      if (!JobUtils.checkJobCustomerIdIfSame(this.arSettlementUnitOptional, type, rows, this)) {
        return
      }
      this.addChargeDetailDialog.selectedJobs = rows
      this.addChargeDetailDialog.type = type
      this.addChargeDetailDialog.selectedScheme = []
      this.addChargeDetailDialog.visible = true
    },
    // 编辑费用
    async toEditCharge() {
      const selectedJobs = []
      for (const obj of this.selectedRows) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessOrIsNotOperationalState'))
        return
      }
      if (!await this.validateChargeLocked(selectedJobs)) return
      this.editChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.editChargeDetailDialog.selectedJobs = selectedJobs
      this.editChargeDetailDialog.visible = true
    },
    // 批量导入费用
    async toImportCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        } else {
          this.$message.warning(this.$t('Message.AllDataMustBeOperating'))
          return
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      if (selectedJobs.length > 500) {
        this.$message.info(this.$t('Message.TheNumberOfSelectedDataLimited') + 500)
        return
      }

      // 将相同的委托单位、订舱代理、承运人、整拼类型、货物类型、起运港、目的港、目的港代理带入到费用方案窗口
      let isSameCustomer = true
      let isSameBookingAgent = true
      let isSameCarrierId = true
      let isSameContainerLoadType = true
      let isSameCargoType = true
      let isSameLoadingPort = true
      let isSameDestinationPort = true
      let isSameDestinationAgent = true
      let isSameVesselLine = true
      const containerLoadType = selectedJobs[0].containerLoadType
      const customerId = selectedJobs[0].customerId
      const bookingAgent = selectedJobs[0].bookingAgent
      const carrierId = selectedJobs[0].carrierId
      const cargoType = selectedJobs[0].cargoType
      const loadingPort = selectedJobs[0].loadingPortCode
      const destinationPort = selectedJobs[0].destinationPortCode
      const destinationAgent = selectedJobs[0].destinationAgent
      let vesselLine = ''
      const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', selectedJobs[0].dischargingPortCode)
      if (port) {
        vesselLine = port.region
      }
      for (const ieJob of selectedJobs) {
        if (!this.addChargeDetailDialog.visible) {
          if (ieJob.containerLoadType !== containerLoadType) {
            this.$message.info(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheContainerLoadType'))
            return
          }
        }
        if (customerId !== ieJob.customerId) {
          isSameCustomer = false
        }
        if (bookingAgent !== ieJob.bookingAgent) {
          isSameBookingAgent = false
        }
        if (carrierId !== ieJob.carrierId) {
          isSameCarrierId = false
        }
        if (containerLoadType !== ieJob.containerLoadType) {
          isSameContainerLoadType = false
        }
        if (cargoType !== ieJob.cargoType) {
          isSameCargoType = false
        }
        if (loadingPort !== ieJob.loadingPortCode) {
          isSameLoadingPort = false
        }
        if (destinationPort !== ieJob.destinationPortCode) {
          isSameDestinationPort = false
        }
        if (destinationAgent !== ieJob.destinationAgent) {
          isSameDestinationAgent = false
        }
        const seaPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', ieJob.dischargingPortCode)
        if (seaPort && vesselLine !== seaPort.region) {
          isSameVesselLine = false
        }
      }
      const sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameBookingAgent) {
        sameCondition['bookingAgent'] = bookingAgent
      }
      if (isSameCarrierId) {
        sameCondition['carrierId'] = carrierId
      }
      if (isSameContainerLoadType) {
        sameCondition['containerLoadType'] = containerLoadType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameLoadingPort) {
        sameCondition['loadingPort'] = loadingPort
      }
      if (isSameDestinationPort) {
        sameCondition['destinationPort'] = destinationPort
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      if (isSameVesselLine) {
        sameCondition['vesselLine'] = vesselLine
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.chargeType = this.addChargeDetailDialog.visible ? this.chargeTypeDialog.type : null
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.isSea = true
      this.chargeSchemeBatchDialog.lob = 'IE'
      this.chargeSchemeBatchDialog.job = selectedJobs[0]
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    // 删除费用（待优化，两个接口可以合并成一个接口）
    async toDeleteCharge() {
      const selectedJobs = []
      const jobKeys = []
      const jobs = this.gridApi.getSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          jobKeys.push(obj.uuid)
          selectedJobs.push(obj)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.deleteChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.deleteChargeDetailDialog.selectedJobs = selectedJobs
      this.deleteChargeDetailDialog.visible = true
    },
    // 删除费用处理结果
    batchCheckRemoveChargeResult(res) {
      const canDeleteChargeKeys = res.data
      if (canDeleteChargeKeys && canDeleteChargeKeys.length > 0) {
        batchRemoveCharge(canDeleteChargeKeys).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
          } else {
            this.$message.error(this.$t('Integrated.OperationFailed'))
          }
        })
      } else {
        this.$message.warning(this.$t('Message.NoCostToRemove'))
      }
    },
    // 验证费用锁定状态
    async validateChargeLocked(jobs) {
      if (jobs && jobs.length > 0) {
        let pass = true
        const keys = []
        for (const item of jobs) {
          if (item.uuid) {
            keys.push(item.uuid)
          }
        }
        await validateChargeLockStatus(keys).then(res => {
          pass = res.data
        }).catch()
        if (!pass) {
          this.$message.warning(this.$t('SeaExport.ChargeLocked'))
          return false
        }
      }
      return true
    },
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      const loading = getLoading4Cxt(this)
      this.filterJson = {}
      this.filterJson.pageNum = this.pageNum
      this.filterJson.pageSize = this.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.modifiedBy = this.$store.getters.userId
      this.filterJson.integratedLogisticsType = this.integratedLogisticsType
      queryLastModifyBookingByDay(this.filterJson).then(res => {
        this.rowData = SopUtil.resolveSopState(res.data.list)
        this.pageNum = res.data.pageNum
        this.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
        this.pageCount = res.data.pages
        if (this.gridApi) this.gridApi.clearFocusedCell()
      }).finally(() => {
        loading.close()
      })
    },
    async init() {
      this.customSearchItems = await this.getCustomSearchItems()
    },
    // 组装查询条件
    async getCustomSearchItems() {
      const defaultSearchFields = []

      let searchField = new AdvancedSearchField()
      const verifyStatus = Array.from(SystemConstants.VERIFY_STATES)
      if (this.pretrialReviewConfig) {
        verifyStatus.push(SystemConstants.VERIFYING_REVIEW_THROUGH)
        verifyStatus.push(SystemConstants.VERIFYING_REVIEW_REFUSAL)
      }
      // 预审状态
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.PREVERIFY_STATE'
      searchField.itemLabel = 'SeaExport.PreverifyStatus'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_SystemConstants$VERIFY_STATES'
      searchField.dataCacheKey = ''
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = verifyStatus
      defaultSearchFields.push(searchField.formatObj2Json())

      const cityList = await getLocationList({}).then((res) => {
        return res.data.list || []
      })
      // 门点城市
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'trucking.CITY_CODE'
      searchField.itemLabel = 'SeaExport.DoorCity'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 0
      searchField.dataProvider = cityList
      defaultSearchFields.push(searchField.formatObj2Json())

      // 目的地门点城市
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'itInfo.CITY_CODE'
      searchField.itemLabel = 'SeaExport.DestinationGatewayCity'
      searchField.tagValue = 'code'
      searchField.defaultSelected = 0
      searchField.dataProvider = cityList
      defaultSearchFields.push(searchField.formatObj2Json())
      if (this.useOrderCenterMode && this.orderCenterBranch) {
        // 协作分公司
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ' && p.code !== this.$store.getters.currentOffice.code).sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1) // 其他分公司
        offices.forEach(row => { row.code = row.officeId }) // ID
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作任务创建时间
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'cooperate.DATE_CREATED'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateCreatedDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (!this.bookingAgentVisible) {
        // 移除订舱代理
        searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': 'bookingAgent',
          'tagValue': 'cmpIdx'
        }
        searchField.fieldType = 'FIELD_BOOKING_AGENT'
        searchField.itemName = 'job.BOOKING_AGENT'
        searchField.itemLabel = 'SeaExport.BookingAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true,
        'includeAllOffice': this.conditonDisplayAllBranchData
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        const saleProductList = getFilterCacheList(this.TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true && mapping.intergraed === true
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      for (const item of this.defaultSearchItems) {
        if (item.itemName === 'job.CUSTOMER_ID' && item.fieldType === 'FIELD_COMPANY') {
          continue
        }
        if (item.itemType === 'userSea' || item.itemType === 'user') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.officeId = ''
          }
          defaultSearchFields.push(newItem)
        } else if (item.itemType === 'company' || item.itemType === 'office' || item.itemType === 'department5') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.includeAllOffice = true
          }
          defaultSearchFields.push(newItem)
        }
      }
      if (this.hierarchyViewList) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      // CARGO-49237 集卡拖车和整车零担 不需要卡航报关（实际时间） 、卡航入境（实际时间）、卡航出境（实际时间）、中转地申报完成（实际时间）
      if (this.integratedLogisticsType && (this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code || this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code)) {
        searchField = new AdvancedSearchField()
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemName = 'ieJob.DECLARE_TIME'
        searchField.itemLabel = 'CargoMsg.Cargo_khDeclareActTime'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())

        searchField = new AdvancedSearchField()
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemName = 'ieJob.ACT_ENTRY_TIME'
        searchField.itemLabel = 'CargoMsg.Cargo_khEntryActTime'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())

        searchField = new AdvancedSearchField()
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemName = 'ieJob.ACT_EXIT_TIME'
        searchField.itemLabel = 'CargoMsg.Cargo_khExitActTime'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())

        searchField = new AdvancedSearchField()
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemName = 'ieJob.DECLARE_COMPLETED_TIME'
        searchField.itemLabel = 'CargoMsg.Cargo_transferDeclareCompletedActTime'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // CARGO-49237 集卡拖车、整车零担、国际卡航 单个页签 去掉综合物流类型
      if (this.integratedLogisticsType) {
        searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'ieJob.CONTAINER_LOAD_TYPE'
        searchField.itemLabel = 'SeaExport.ComprehensiveLogisticsOrderType'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'ieJob.SECOND_PLATE_NUMBER'
        searchField.itemLabel = 'CargoMsg.Cargo_secondPlateNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$store.state.uiCustom.enable && this.integratedLogisticsType) {
        if (this.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
          UICustomUtil.handleSearchItems(UICustomConstants.IC_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
        } else if (this.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
          UICustomUtil.handleSearchItems(UICustomConstants.CL_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
        } else if (this.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
          UICustomUtil.handleSearchItems(UICustomConstants.TT_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
        }
      }
      return defaultSearchFields
    },
    // 批量操作
    batchHandle(val) {
      if (val !== 4) {
        if (this.hierarchyViewList) {
          if (val !== 6) {
            this.checkOwnerBranch(this.selectedRows)
          }
        }
      }
      switch (val) {
        case 1:
          this.toShutOut()
          break
        case 2:
          this.toBatchSubmit()
          break
        case 3:
          this.toBatchPreSubmit()
          break
        case 4:
          this.toBatchManagerSubmission()
          break
        case 5: // 批量撤回预提交
          this.toBatchReturnPreSubmit()
          break
        case 6: // 批量退回提交
          this.toBatchReturnSubmit()
          break
        case 7: // 批量修改自定义业务类型
          this.toBatchUpdateCustomType()
          break
        case 8:
          this.toBatchModifyChargeLockStatus(true)
          break
        case 9:
          this.toBatchModifyChargeLockStatus(false)
          break
        case 10:
          this.toBatchModifyChargeLockingStatus(true)
          break
        case 11:
          this.toBatchModifyChargeLockingStatus(false)
          break
        case 17:
          this.toBatchModifyBusiness()
          break
        case 18:
          this.toBatchUpdateSopTemplate()
          break
        case 19:
          this.toBatchCooperation()
          break
        case 20:
          JobUtils.toBatchFillGpExplain(this.readSelectedRows(), this.gpExplain)
          break
        case 21:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), true, this.toQuery)
          break
        case 22:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), false, this.toQuery)
          break
        case 23:
          this.toBatchSyncChargeConfirm()
          break
        case 24:
          JobUtils.batchReturnReview(this, this.readSelectedRows())
          break
      }
      if (typeof val === 'string') {
        if (val.startsWith('instruction,')) {
          const tenantInstructionUuid = val.split(',')[1]
          const item = this.instructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
          if (item) {
            if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
              if (!this.$store.getters.isGroupCompany) {
                this.$message.warning(this.$t('SystemMaintenance.NonNotSupportCrossTenants'))
                return
              }
              this.$refs.tenantEntrustWindow.onShowOfUI(item, this.readSelectedRows())
            }
          }
        }
      }
    },
    onInstructionCallback(data) {
      this.loadInstructionButtons()
      if (data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
        this.toQuery()
      }
    },
    // 批量推送费用(交叉委托)
    toBatchSyncChargeConfirm() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const j of rows) {
        jobKeys.push(j.uuid)
      }
      this.loading = getLoading()
      syncChargeConfirmBatch(jobKeys).then(res => {
        this.$message.success(this.$t('queryJob.GenerateXChargeSyncRecords', { num: res.data }))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 批量修改自定义业务类型
    toBatchUpdateCustomType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.warning(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.customJobTypeDialog.jobKeys = jobKeys
      this.customJobTypeDialog.jobList = jobList
      this.customJobTypeDialog.visible = true
    },
    // 批量修改自定义业务类型点击确定
    customJobTypeClickHandler() {
      const jobs = this.customJobTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        const obj = {}
        obj.jobUuids = this.customJobTypeDialog.jobKeys
        obj.customJobType = this.customJobTypeDialog.customJobType
        this.loading = getLoading()
        updateJobCustomJobType(obj).then(res => this.updateJobCustomJobTypeResult(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    // 批量修改自定义业务类型 处理结果
    updateJobCustomJobTypeResult(res) {
      this.loading.close()
      if (res.data) {
        this.$message.success(this.$t('SeaExport.CustomJobTypeBatchModifySuccess') + res.data)
        for (const seaJob of this.customJobTypeDialog.jobList) {
          seaJob.customJobType = this.customJobTypeDialog.customJobType
        }
        this.toQuery()
      }
      this.customJobTypeDialog.visible = false
      this.customJobTypeDialog.customJobType = ''
      this.customJobTypeDialog.jobKeys = []
      this.customJobTypeDialog.jobList = []
    },
    readSelectedRows(tips = true) {
      const allRows = this.gridApi.getSelectedRows()
      if (allRows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return allRows
    },
    // 批量解锁应收/应付费用
    async toBatchModifyChargeLockStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new IntegratedJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.UnlockChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 0 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullyUnlockedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量锁定应收/应付费用
    async toBatchModifyChargeLockingStatus(receivable) {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new IntegratedJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.LockingChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 1 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullylockingedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量撤回提交
    async toBatchReturnSubmit() {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.COMMITED)) {
          this.$message.warning(this.$t('SeaExport.BatchReturnSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Withdraw') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'IE' }).then(res => {
            this.loading.close()
            if (res.data) {
              this.toQuery()
            }
            this.$message.success(this.$t('SeaExport.SuccessWithdraw', [res.data ? res.data.length : 0]))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量撤回预提交
    async toBatchReturnPreSubmit() {
      const rows = this.selectedRows
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchReturnPreSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_RETURN_ACTION.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Return') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading4Cxt()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'IE' }).then(res => {
            this.loading.close()
            if (res.data) this.toQuery()
            this.$message.success(this.$t('Message.AlreadyReturn'))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量主管提交
    async toBatchManagerSubmission() {
      let rows = []
      let jobKeys = []
      for (const j of this.selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!this.allowPartialCheckPass) {
          if (Number(j.jobState) !== Number(SystemConstants.OPERATING) && Number(j.jobState) !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('SeaExport.BatchManagerSubmissionTips'))
            return
          }
        }
        jobKeys.push(j.uuid)
        rows.push(j)
      }
      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            rows = []
            for (const j of this.selectedRows) {
              if (jobKeys.indexOf(j.uuid) !== -1) {
                rows.push(j)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_MANAGER_COMMIT.code
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          const callBack = this.batchBatchManagerSubmissionCall || null
          this.checkingManager(rows, checkNode, callBack, null, this.allowPartialCheckPass)
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesManagerSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }).catch(() => {
          })
        }
      }
    },
    batchBatchManagerSubmissionCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        batchManagerCommit({ jobKeys: jobKeys, officeId: this.$store.getters.currentOfficeId }).then(res => this.handlerBatchManagerSubmissionResult(res))
      }
    },
    // 批量主管提交处理结果
    handlerBatchManagerSubmissionResult(res) {
      const len = res.data ? res.data.length : 0
      this.$message.success(this.$t('SeaExport.BatchManagerSubmissionSuccessfully') + len)
      this.toQuery()
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    async initColumnDefs() {
      // CARGO-31277 SOPSOP节点显示列增加
      const sopColumns = await SopUtil.getSopColumns('IE')
      if (!this.bookingAgentVisible) {
        this.columnDefs = this.columnDefs.filter(p => p.field !== 'bookingAgent')
      }
      this.columnDefs = [...this.columnDefs, ...sopColumns]
      await JobUtils.enrichTotalRevenueColumnDefs(this.columnDefs, this)
      if (this.isZY) {
        this.columnDefs.push(
          {
            headerName: this.$t('CargoMsg.AllowSaleProduct'),
            field: 'saleProductCode',
            colId: 'saleProductCode',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(this.TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.FullOrInside'),
            field: 'fullOrInside',
            colId: 'fullOrInside',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.fullOrInsideLabelFun(params.value)
            }
          }
        )
      }
    },
    sopStateDialogClose() {
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', false)
    },
    // 批量修改业务
    toBatchModifyBusiness() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.maxSelectBusiness', ['200']))
        return
      }
      this.batchModifyBusinessDialog.lob = 'IE'
      this.batchModifyBusinessDialog.jobList = rows
      this.batchModifyBusinessDialog.jobKeys = Array.from(rows, p => p.uuid)
      this.batchModifyBusinessDialog.visible = true
    },
    // 批量修改业务成功后，弹窗回调
    batchModifyBusinessCallback() {
      this.toQuery()
    },
    // 批量更换SOP模板
    toBatchUpdateSopTemplate() {
      const rows = this.readSelectedRows()
      JobUtils.batchUpdateSopTemplate(this, rows)
    },
    // 批量发起协作
    toBatchCooperation() {
      this.batchCooperationDialog.jobList = this.readSelectedRows()
      this.batchCooperationDialog.visible = true
    },
    reload() {
      this.toQuery()
    },
    preColumnStateCallback(columnState) {
      const index = columnState.findIndex(p => p.colId === 'jobNo')
      if (index === -1) {
        columnState.splice(0, 0, {
          aggFunc: null,
          colId: 'jobNo',
          flex: null,
          hide: false,
          pinned: null,
          pivot: false,
          pivotIndex: null,
          rowGroup: false,
          rowGroupIndex: null,
          sort: null,
          sortIndex: null,
          width: 100
        })
      }
      return columnState
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    // 审核通过
    acceptHandler() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('SeaExport.SelectARecord'))
        return
      }
      this.acceptDialog.jobs = this.readSelectedRows(false)
      if (!this.acceptDialog.jobs || this.acceptDialog.jobs.length <= 0) {
        this.$message.warning(this.$t('SeaExport.CheckApproved'))
        return
      }
      // 协作状态: 审核通过
      const cooperateList = []
      for (const seaJob of this.acceptDialog.jobs) {
        if (this.isCooperate(seaJob.cooperateStatus)) { cooperateList.push(seaJob.uuid) }
      }
      if (cooperateList.length > 0) {
        if (cooperateList.length !== this.acceptDialog.jobs.length) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateReviewSeparately'))
          return
        }
        this.acceptCooperateHandler(cooperateList)
        return
      }
      const jobArr = []
      for (const job of this.acceptDialog.jobs) {
        if (job.jobState !== -1 || job.preverifyState === 2 || job.preverifyState === 3) {
          jobArr.push(job.jobNo)
        }
        if (this.pretrialReviewConfig && (job.preverifyState === 5 || job.preverifyState === 6)) {
          jobArr.push(job.jobNo)
        }
      }
      if (jobArr.length > 0) {
        const str = this.pretrialReviewConfig ? `${this.$t('Message.Approved')}/${this.$t('CargoMsg.Cargo_Denied')}/${this.$t('SeaExport.VerifyReviewThrough')}/${this.$t('SeaExport.ReviewRejectedBusinessNumber')}` : `${this.$t('Message.Approved')}/${this.$t('SeaExport.RejectedBusinessNumber')}`
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobArr.join(','))
        ])
        this.$alert(content, str)
        return
      }
      this.acceptDialog.job = this.acceptDialog.jobs[0]
      this.acceptDialog.submitCallBack = this.acceptSubmitCallBack
      this.acceptDialog.visible = true
    },
    async acceptSubmitCallBack(result) {
      this.acceptDialog.result = result
      if (result) {
        const jobKeys = Array.from(this.acceptDialog.jobs, p => p.uuid)
        this.acceptDialog.result.jobKeys = jobKeys
        const callBack = () => {
          const loading = getLoading4Cxt(this)
          batchCheckJobsCredit(jobKeys).then(res => {
            this.checkCreditResultHandler(res)
          }).finally(() => {
            loading.close()
          })
        }
        // 判断是否开启验证规则
        if (this.useCheckRule) {
          // const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, 'IE')
          const hasCheckRule = true
          if (hasCheckRule) {
            this.batchCheckingWindow.jobs = this.acceptDialog.jobs
            if (this.allowPartialCheckPass) {
              this.checkingManager(this.acceptDialog.jobs, CheckRuleConstants.NODE_BOOKING_VERIFY.code, callBack, null, true, result)
            } else {
              this.checkingManager(this.acceptDialog.jobs, CheckRuleConstants.NODE_BOOKING_VERIFY.code, callBack, null, false, result)
            }
          } else {
            callBack()
          }
        } else {
          callBack()
        }
      }
    },
    // 信控验证返回结果
    checkCreditResultHandler(res) {
      const result = res.data
      if (result && this.creditRestrictionForBooking !== 0) {
        if (this.creditRestrictionForBooking === 2) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipOne')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = false
          this.confirmDialogWindow.confirmCallBack = null
          this.confirmDialogWindow.visible = true
          return
        }
        if (this.creditRestrictionForBooking === 1) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipTwo')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = true
          this.confirmDialogWindow.confirmCallBack = this.batchAudit
          this.confirmDialogWindow.visible = true
          return
        }
      }
      this.batchAudit()
    },
    // 审核通过
    batchAudit() {
      const loading = getLoading4Cxt()
      acceptJobFunc(this.acceptDialog.result).then(res => {
        this.$message.success(this.$t('AirExport.ReviewSucceeded'))
        this.toQuery()
      }).finally(() => {
        loading.close()
      })
    },
    // 拒绝
    rejectHandler() {
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      // 协作业务不支持批量拒绝
      if (jobs.length > 1) {
        for (const job of jobs) {
          if (this.isCooperate(job.cooperateStatus)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CollabBatchRejectError', [job.jobNo]))
            return
          }
        }
      }
      let rejectCallBack = this.rejectCallBackHandler
      if (jobs.length === 1) {
        const job = jobs[0]
        if (this.isCooperate(job.cooperateStatus)) {
          rejectCallBack = this.rejectCooperateCallBackHandler
        }
      }
      this.rejectWindow.jobNo = this.selectedRow ? this.selectedRow.jobNo : ''
      this.rejectWindow.jobList = jobs
      this.rejectWindow.rejectCallBack = rejectCallBack
      this.rejectWindow.visible = true
    },
    rejectCallBackHandler(remark) {
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length === 0) {
        return
      }
      const jobKeys = Array.from(jobs, p => p.uuid)
      const loading = getLoading4Cxt()
      batchPreVerifyRejectFunc({ 'jobKey': jobKeys, 'remark': remark }).then(res => {
        this.$message.success(this.$t('SeaExport.RefuseSuccess'))
        this.toQuery()
      }).finally(() => {
        loading.close()
      })
    },
    // 复核通过
    btVerifyReviewThroughHandler(type) {
      if (!this.selectedRow || !this.selectedRow.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      const jobs = this.readSelectedRows(false)
      if (!jobs || jobs.length <= 0) {
        this.$message.warning(this.$t('SeaExport.CheckApproved'))
        return
      }
      const jobNos = []
      for (const job of jobs) {
        if (this.isCooperate(job.cooperateStatus)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
          return
        }
        if (!(parseInt(job.jobState) === -1 && parseInt(job.preverifyState) === 2)) {
          jobNos.push(job.jobNo)
        }
      }
      if (jobNos.length > 0) {
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobNos.join(','))
        ])
        this.$alert(content, this.$t('SeaExport.UnreviewedBusinessNumber2'))
        return
      }
      const jobKeys = Array.from(jobs, p => p.uuid)
      const item = {}
      item.uuid = jobKeys[0]
      item.preverifyState = 5
      item.jobKeys = jobKeys
      const loading = getLoading4Cxt()
      reviewThroughFunc(item).then(res => {
        this.$message.success(this.$t('SeaExport.ReviewSuccess'))
        this.toQuery()
      }).finally(() => {
        loading.close()
      })
    },
    // 复核拒绝
    btVerifyReviewRefusalHandler() {
      if (!this.selectedRow || !this.selectedRow.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (this.isCooperate(this.selectedRow.cooperateStatus)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CooperateNoPretrialReview'))
        return
      }
      const loading = getLoading4Cxt()
      const item = {}
      item.uuid = this.selectedRow.uuid
      item.preverifyState = 6
      reviewRefusalFunc(item).then(res => {
        this.$message.success(this.$t('SeaExport.ReviewRejectedSuccess'))
        this.toQuery()
      }).finally(() => {
        loading.close()
      })
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(cooperateList) {
      if (!cooperateList || cooperateList.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuids = cooperateList
      this.cooperationVerifyDialog.jobUuid = this.selectedRow.uuid // 显示其中一笔
      const cooperate = {
        branchId: this.selectedRow.cooperateBranchId,
        opId: this.selectedRow.cooperateOpId,
        csrId: this.selectedRow.cooperateCsrId,
        overseaOp: this.selectedRow.cooperateOverseaOp,
        dcId: this.selectedRow.cooperateDcId,
        planner: this.selectedRow.cooperatePlanner,
        sales: this.selectedRow.cooperateSales,
        cargoSalesId: this.selectedRow.cooperateCargoSalesId,
        userDefinedRoleId1: this.selectedRow.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.selectedRow.cooperateUserDefinedRoleId2,
        businessType: this.selectedRow.cooperateBusinessTypeCode ? this.selectedRow.cooperateBusinessTypeCode.split(',') : []
      }
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuids: this.cooperationVerifyDialog.jobUuids, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.selectedRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
          this.toQuery()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    toChangeSchema() {
      // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
      this.toImportCharge()
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = this.readSelectedRows()
      this.addChargeDetailDialog.chargeType = this.chargeTypeDialog.type
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    }
  }
}
